import './CSS/Estilo.css';
import {estiloGreen,estiloDark} from "./CSS/EstilosPagina";
import ToolBar from "./Componentes/SubComponentes/ToolBar";
import MenuDesplegable from "./Componentes/MenuDesplegable";
import BtOrax from "./Componentes/SubComponentes/BtOrax";
import Box from '@mui/system/Box';
import ChipUser from './Componentes/SubComponentes/ChipUser';
import MenuGestionUsuarios from './Componentes/MenuGestionUsuarios';
import MenuGestionFicheros from './Componentes/MenuGestionFicheros';
import FormularioDatosUsuario from './Componentes/FormularioDatosUsuario';
import FormularioBusqueda from './Componentes/FormularioBusqueda';
import OraxTable from './Componentes/SubComponentes/OraxTable'
import FilePicker from './Componentes/SubComponentes/FilePicker';
import WebTheme from "./Componentes/SubComponentes/WebTheme";
import {useState, useEffect, useCallback} from "react";
import {fetchRequest} from "./Componentes/RequestUtils";
import Dialogo from "./Componentes/SubComponentes/Dialogo";
import {jwtDecode} from 'jwt-decode';


export default function OraxAdmin(props){
    /* States */
    const opciones = ['Dark','Green']
    const [estiloPagina,setEstiloPagina]=useState((localStorage.getItem('estilo') === 'Dark')?estiloDark
        :estiloGreen);
    const[tipoGestion,setTipoGestion]=useState('Ficheros');
    const[clicado,setClicado] = useState('');
    const[formulario,setFormulario] = useState();
    const[formFichero,setFormFichero] = useState();
    const[listaUsuarios,setListaUsuarios] = useState([]);
    const[listaVisible,setListaVisible] = useState(false);
    const[datosUsuario,setDatosUsuario] = useState({});
    const[datosEdicion,setDatosEdicion] = useState(null);
    const[dialogo,setDialogo] = useState();

    /* Constantes globales */
    const pages = ((datosUsuario.admin)?[ 'Ficheros','Usuarios']:['Ficheros','Editar perfil']);
    const userListColumns = [
        { field: 'uid', headerName: 'Nombre de usuario', width:(window.innerWidth*0.11),
            headerClassName: ((localStorage.getItem('estilo') === 'Green')?'headerUsersTableG':'headerUsersTableD')
            ,headerAlign:'center',align:'center', cellClassName:'lineasTablaDerecha'},
        { field: 'admin', headerName: 'Admin', width:(window.innerWidth*0.1),
            headerClassName: ((localStorage.getItem('estilo') === 'Green')?'headerUsersTableG':'headerUsersTableD'),headerAlign:'center',align:'center',
            cellClassName:'lineasTablaDerecha'},
        { field: 'cn', headerName: 'Nombre', width: (window.innerWidth*0.13), headerAlign:'center',align:'center',
            headerClassName: ((localStorage.getItem('estilo') === 'Green')?'headerUsersTableG':'headerUsersTableD'),cellClassName:'lineasTablaDerecha'},
        { field: 'sn', headerName: 'Apellido', width: (window.innerWidth*0.13),headerAlign:'center',align:'center',
            headerClassName: ((localStorage.getItem('estilo') === 'Green')?'headerUsersTableG':'headerUsersTableD'),cellClassName:'lineasTablaDerecha'},
        { field: 'postalAddress', headerName: 'Direccion', width: (window.innerWidth*0.225),headerAlign:'center',align:'center',
            headerClassName: ((localStorage.getItem('estilo') === 'Green')?'headerUsersTableG':'headerUsersTableD'),cellClassName:'lineasTablaDerecha'},
        { field: 'postalCode', headerName: 'C.P.', width: (window.innerWidth*0.05),headerAlign:'center',align:'center',
            headerClassName: ((localStorage.getItem('estilo') === 'Green')?'headerUsersTableG':'headerUsersTableD'),cellClassName:'lineasTablaDerecha'},
        { field: 'mail', headerName: 'e-mail', width: (window.innerWidth*0.15),headerAlign:'center',align:'center',
            headerClassName: ((localStorage.getItem('estilo') === 'Green')?'headerUsersTableG':'headerUsersTableD'),cellClassName:'lineasTablaDerecha'},
        { field: 'telephoneNumber', headerName: 'Teléfono', width: (window.innerWidth*0.1),headerAlign:'center',align:'center'
            ,headerClassName: ((localStorage.getItem('estilo') === 'Green')?'headerUsersTableG':'headerUsersTableD')},
    ];
    //Encapsular configuracion comun de formularios en un objeto
    const configForms={
        estiloPagina:estiloPagina,
        ip:props.ip,
        port:props.port,
        protocolo:props.protocolo}

    //////////////////////////////////////////
    //
    // HACE UNA PETICION AL SERVIDOR DE LOS DATOS grupo y admin ( TRUE SI ES ADMINISTRADOR )
    // AL SERVIDOR Y LAS SETEA EN EL State datosUsuario. TAMBIEN PONE EN sessionStorage LA
    // GESTION INICIAL QUE SE MOSTRARÁ AL USUARIO
    //
    ///////////////////////////////////////////////////////////
    //
    const mostrarUsuario = useCallback(() =>
    {
        const callback = (response) => {
            if (response) {
                let datos = JSON.parse(response.data.datosUsuario);
                setDatosUsuario(() => datos);
                if (!datos.admin)
                    sessionStorage.setItem('Gestion', 'Ficheros');
            }
        }
        let token = sessionStorage.getItem('token');
        let decodedToken = jwtDecode(token);
        fetchRequest('datosUsuario', [{nombre: 'hashedpwd', valor: decodedToken.hashedPassword}],
            'POST', props.ip, props.port, props.protocolo, 'json', callback);

    },[props.ip, props.port, props.protocolo]);

    ///////////////////////////////////
    //
    // CUANDO SE PULSA EN ALGUNA OPCION DEL TOOLBAR, ESTE SETEA LOCALSTORAGE
    // Y ESTA FUNCION LA LEE Y SETEA EL STATE tipoGestion EN CONSECUENCIA
    //
    ///////////////////////////////////////////////
    //
    useEffect(()=>{
        let gestion = localStorage.getItem('Gestion');
        if(gestion)
            setTipoGestion(() => gestion);
        mostrarUsuario();
        if(gestion ==='Editar perfil')
            mostrarFormularioEdicion();
    },[mostrarUsuario]);

    const opcionesOnClick = useCallback((ev) => {
        let pulsado = ev.target.id;
        let estilo = (pulsado === 'Dark')?estiloDark:estiloGreen;
        setEstiloPagina(() => estilo);
        localStorage.setItem('estilo',pulsado);
    },[]);

  ///////////////////////////////
  //
  // MANEJADOR DEL EVENTO DE HACER CLICK SOBRE UN BOTON DEL MENU DE USUARIOS.
  // ASIGNA A LA PROPIEDAD formulari DEL ESTADO,
  // EL FORMULARIO QUE SE MOSTRARÁ SEGUN EL BOTON PULSADO
  //
  /////////////////////////////////////////////
  //
  function asignaForm(ev){
    resetearColorBotones();
    let objetivo;
    if(ev.target.id && document.getElementById(ev.target.id).tagName === 'BUTTON')
        objetivo = ev.target;
    else
        objetivo = ev.target.parentElement;

    objetivo.style.background = 'chartreuse';
    objetivo.style.color = 'green';
    let id = objetivo.id;
    //Ocultar el formulario si és la segunda vez que se clica el botón
    if (clicado === id) {
        window.location.reload();
        return;
      }
    setClicado(()=>id );
    //Poner un formulario en función del nombre del boton clicado    
    switch (id) {
      case "btNou": //botón de nuevo usuario
        setFormulario(() =>  <FormularioDatosUsuario
                                config={configForms}
                                rotulo={'Formulario para nuevo usuario'}
                                >
                            </FormularioDatosUsuario> );
        break;
      case "btEdit":
        setFormulario(()=><FormularioBusqueda
                            config={configForms}
                            rotuloForm={"Usuario a editar"}
                            onClick={ () => enviarDatosBusqueda()}>
                             </FormularioBusqueda>);
        break;
      case "btBorra":
          setFormulario(()=><FormularioBusqueda
              config={configForms}
              rotuloForm={"Usuario a borrar"}
              onClick={()=>enviarDatosBusqueda(true)}>
          </FormularioBusqueda>);
        break;
      case "btList":
        const callback = (response) =>{
            if(response) {
                let datos = response.data.getUsersList;
                if (datos.length > 0) {
                    setListaVisible(()=>true);
                    setListaUsuarios(()=>datos);
                } else
                    alert("No se han podido obtener datos de usuarios.");
            }
            else
                alert("Sin respuesta del servidor.");
        }
        fetchRequest("getUsersList",[{nombre:'token',valor:sessionStorage.getItem('token')}],'POST',
            props.ip,props.port,props.protocolo,'json',callback,
            [['cn','sn','mail','uid','telephoneNumber','postalAddress','postalCode','admin','id']])
        break;
      default:
        //setFormulario(()=> formClear );
        break;
    }
  }

  ///////////////////////////////
  //
  // MANEJADOR DEL EVENTO DE HACER CLICK SOBRE UN BOTON DEL MENU DE FICHEROS
  // ASIGNA A LA PROPIEDAD formFichero DEL ESTADO,
  // EL FORMULARIO O WIDGET QUE SE MOSTRARÁ SEGUN EL BOTON PULSADO
  //
  /////////////////////////////////////////////
  //
  function asignaFormFicheros(ev) {
      let ip = props.ip;
      let protocolo = props.protocolo;
      let port = props.port;
      resetearColorBotones();
      let objetivo;
      if (ev.target.id && document.getElementById(ev.target.id).tagName === 'BUTTON')
          objetivo = ev.target;
      else
          objetivo = ev.target.parentElement;
      objetivo.style.background = 'aqua';
      objetivo.style.color = 'blue';
      let id = objetivo.id;
      //Ocultar el formulario o widget si és la segunda vez que se clica el botón
      if (clicado === id) {
          window.location.reload();
          return;
      }
      //Poner el id del boton clicado en el estado
      setClicado(() => id);
      //Poner un formulario en función del nombre del boton clicado
      switch (id) {
          case "btFileUpload": //botón de subir ficheros
              //Para local
              if(props.modo_desarrollo) {
                  setFormFichero(() => <FilePicker user={sessionStorage.getItem('token')} uploadURL={protocolo +
                      ip + ':' + port + '/fileUpload'} directory={false}></FilePicker>);
              }
              //Para reverse proxy
              else
                setFormFichero(() => <FilePicker user={sessionStorage.getItem('token')} uploadURL={'/api/fileUpload'} directory={false}></FilePicker>);
              break;
          case "btDirectoryUpload": //boton de subir directorios
              //Para local
              if(props.modo_desarrollo) {
                  setFormFichero(() => <FilePicker user={sessionStorage.getItem('token')} uploadURL={protocolo +
                      ip + ':' + port + '/fileUpload'} directory={true}></FilePicker>);
              }
              //Para reverse proxy
              else
                setFormFichero(() => <FilePicker user={sessionStorage.getItem('token')} uploadURL={'/api/fileUpload'} directory={true}></FilePicker>);
              break;
          default:
              break;
      }
  }

    //////////////////////
    //
    // MANEJADOR DEL BOTON DE ENVIO DEL FORMULARIO DE BUSQUEDA
    // DE DATOS DE USUARIO
    // COMPRUEBA LOS DATOS INTRODUCIDOS EN EL FORMULARIO Y
    // EN CASO DE SER CORRECTOS LOS ENVIA.
    // EL SERVIDOR ENVIA UN OBJETO CON LOS DATOS DEL USUARIO
    // O NULL SI NO SE ENCUENTRA EL USUARIO
    //
    // SI SE HA ENCONTRADO AL USUARIO, Y EL PARAMETRO OPCIONAL borrar
    // NO ES UNDEFINED, SE MUESTRA UN DIALOGO DE CONFIRMACION PARA
    // BORRAR LOS DATOS DEL USUARIO EN EL SERVIDOR.
    // SI borrar ES UNDEFINED, SE MUESTRA UN FORMULARIO DE EDICION CON
    // CON LOS DATOS RECIBIDOS
    //
    // SI NO SE ENCUENTRA AL USUARIO, SE MUESTRA UN MENSAJE DE ERROR
    //
    /////////////////////////////////
    //
    function enviarDatosBusqueda(borrar){
        //Obtener los datos introducidos
        let uid = document.getElementById("uid").value;
        let token = sessionStorage.getItem('token');
        //Comprobar los datos
        if (uid.length === 0 ) {
            alert("No pueden haber campos vacíos.");
            return;
        }
        //Enviar la petición
        const callback = (response) =>{
            if(response) {
                if(response.data.obtenerDatosUsuario) {
                    let datos = response.data.obtenerDatosUsuario;
                    if(borrar) {
                        setDialogo(()=><Dialogo
                            abierto={true}
                            mensaje={'¿Está seguro de querer borrar los datos y ficheros del usuario: '+datos.uid+' ?'}
                            datosUsuario = {datos}
                            proposito = {'borrar'}
                            config = {configForms}
                        >
                        </Dialogo>);
                    }
                    else {
                        setFormulario(() => <FormularioDatosUsuario
                            config={configForms}
                            rotulo={'Formulario de edición de datos de usuario'}
                            datos={datos}
                            mostrarBotonCancel = {true}
                            btCancelarEdicionClicked={cancelarEdicion}
                        >
                        </FormularioDatosUsuario>);
                    }
                }
                else
                    alert("Usuario no encontrado");
            }
            else
                alert("Error, no se ha recibido respuesta del servidor");
        }
        fetchRequest('obtenerDatosUsuario',
            [{nombre:'uid',valor:uid},{nombre:'token',valor:token}],
            'POST',props.ip,props.port,props.protocolo,'json',callback,
            ['cn','sn','mail','uid','telephoneNumber','postalAddress','postalCode']);
    }

  ///////////////////////////
  //
  // PONE EL COLOR DE LOS BOTONES DE MENU EN SUS VALORES
  // INICIALES
  //
  //////////////////////////////
  //
  function resetearColorBotones() {
    let div = document.getElementById("DivButtons");
    for (let i = 0; i < div.children.length; i++) {
      let boto = div.children[i];
      boto.style.background = (tipoGestion==='Usuarios')?"green":"blue";
      boto.style.color = (tipoGestion==='Usuarios')?"chartreuse":"aqua";
    }
  }

    ///////////////////////////
    //
    // CANCELA LA EDICION DE DATOS DEL USUARIO NO ADMINISTRADOR
    // QUE ESTA EDITANDO SUS DATOS. OCULTA EL FORMULARIO Y MUESTRA
    // EL MENU DE GESTION DE FICHEROS
    //
    //////////////////////////////
    //
    function cancelarEdicion()
    {
        if(datosUsuario.admin)
            localStorage.setItem('Gestion','Usuarios');
        else
            localStorage.setItem('Gestion','Ficheros');
        window.location.reload();
    }

    ////////////////////////////////////////////////
    ///
    //  PIDE AL SERVIDOR LOS DATOS DEL USUARIO ACTUAL Y LOS SETEA
    //  EN EL State datosEdicion PARA QUE SE MUESTREN EN EL FORMULARIO
    //  DE EDICION
    //
    ////////////////////////////////////////////////
    //
  function mostrarFormularioEdicion()
  {
      let uid = sessionStorage.getItem('uid');
      let token = sessionStorage.getItem('token');
      const callback = (response) =>{
          if(response) {
              if(response.data.obtenerDatosUsuario) {
                  setDatosEdicion(()=>response.data.obtenerDatosUsuario)
              }
              else {
                  alert("Usuario no encontrado");
                  setTipoGestion(()=>'Ficheros');
              }
          }
          else
              alert("Error, no se ha recibido respuesta del servidor");
      }
      fetchRequest('obtenerDatosUsuario',
          [{nombre:'uid',valor:uid},{nombre:'token',valor:token}],
          'POST',props.ip,props.port,props.protocolo,'json',callback,
          ['cn','sn','mail','uid','telephoneNumber','postalAddress','postalCode']);
  }

    return(           
        <Box className='Cont' style={{background:estiloPagina.background}}>            
            <Box className='ToolBar'>
                <ToolBar 
                gadgets={[<ChipUser
                                    userName={datosUsuario.uid}
                                    userLevel={(!datosUsuario.admin)?'User':'Admin'} >
                          </ChipUser>,
                          <MenuDesplegable
                                    key='1'
                                    opciones={opciones}
                                    opcionesOnClick={opcionesOnClick}>                                      
                          </MenuDesplegable>,
                          <BtOrax 
                                    color='orange'
                                    id='btSesion'
                                    key='2'
                                    hoverBack='yellow'
                                    hoverColor='red'
                                    modo = {props.modo}>
                          </BtOrax>]}
                    paginas={pages}
                    modo = {props.modo}
                    estilo ={estiloPagina}></ToolBar>   
            </Box>    
            <Box className='Cabecera'>
                 <h1 style={{margin:'auto',color:(estiloPagina.background === 'black')?WebTheme.colors.letraDark:WebTheme.colors.letraGreen,fontWeight:200}}>Admin {(datosUsuario.admin)?tipoGestion:'Ficheros'}</h1>
            </Box>               
            <Box className='ContenidoGestion'/*sx={{background:'blue'}}*/>
                  <Box id="DivMenu">
                    {tipoGestion==='Usuarios' && <MenuGestionUsuarios estiloPagina={estiloPagina} onClick={asignaForm}></MenuGestionUsuarios>}                                                      
                    {tipoGestion==='Ficheros' && <MenuGestionFicheros estiloPagina={estiloPagina} onClick={asignaFormFicheros}></MenuGestionFicheros>}
                  </Box>                
                <Box id="DivForm">             
                        { tipoGestion === 'Usuarios' &&
                            formulario
                        }
                        { tipoGestion ==='Ficheros' &&
                          formFichero
                        }
                        {tipoGestion === 'Editar perfil' && datosEdicion && <FormularioDatosUsuario
                            config={configForms}
                            datos={datosEdicion}
                            rotulo={'Formulario de edición de datos de usuario'}
                            sendToHome={true}
                            btCancelarEdicionClicked ={cancelarEdicion}
                            mostrarBotonCancel = {true}>
                        </FormularioDatosUsuario>}
                </Box>
                {listaVisible && listaUsuarios.length > 0 && <Box id="DivList" sx={{background:estiloPagina.background}}>
                        <OraxTable
                            columns = {userListColumns}
                            rows = {listaUsuarios}
                            tamañoLetra = '1.3em'
                            rotulo = 'Tabla de usuarios'
                        ></OraxTable>
                </Box>}                
            </Box>
            {dialogo?dialogo:null}
        </Box>                     
    );
}
